__turbopack_context__.v({
  "contentWrapper": "vcQ-fG_contentWrapper",
  "item": "vcQ-fG_item",
  "itemTitle": "vcQ-fG_itemTitle",
  "itemsWrapper": "vcQ-fG_itemsWrapper",
  "sectionContainer": "vcQ-fG_sectionContainer",
  "title": "vcQ-fG_title",
});
